import { render, staticRenderFns } from "./IngredientsManager.vue?vue&type=template&id=0cfd5f90&"
import script from "./IngredientsManager.vue?vue&type=script&lang=ts&"
export * from "./IngredientsManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports